import { render } from "./MovesTable.vue?vue&type=template&id=0b5d2a86&scoped=true&ts=true"
import script from "./MovesTable.vue?vue&type=script&lang=ts"
export * from "./MovesTable.vue?vue&type=script&lang=ts"

import "./MovesTable.vue?vue&type=style&index=0&id=0b5d2a86&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b5d2a86"]])